/**
 * @generated SignedSource<<9cdd1ae660f5c2bba9e306ff278a9f98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SlackIntegrationBotMentionsMutation$variables = {
  enabled: boolean;
};
export type SlackIntegrationBotMentionsMutation$data = {
  readonly updateRespondToBotMentions: {
    readonly error: {
      readonly message: string;
    } | null | undefined;
    readonly success: {
      readonly organization: {
        readonly id: any;
        readonly respondToBotMentions: boolean;
      };
    } | null | undefined;
  };
};
export type SlackIntegrationBotMentionsMutation = {
  response: SlackIntegrationBotMentionsMutation$data;
  variables: SlackIntegrationBotMentionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "enabled"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "enabled",
        "variableName": "enabled"
      }
    ],
    "concreteType": "UpdateRespondToBotMentionsResponse",
    "kind": "LinkedField",
    "name": "updateRespondToBotMentions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UpdateRespondToBotMentionsSuccess",
        "kind": "LinkedField",
        "name": "success",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLOrganization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "respondToBotMentions",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UpdateRespondToBotMentionsError",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SlackIntegrationBotMentionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SlackIntegrationBotMentionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ef481c90af46bb0b58f91d17e47dd09c",
    "id": null,
    "metadata": {},
    "name": "SlackIntegrationBotMentionsMutation",
    "operationKind": "mutation",
    "text": "mutation SlackIntegrationBotMentionsMutation(\n  $enabled: Boolean!\n) {\n  updateRespondToBotMentions(enabled: $enabled) {\n    success {\n      organization {\n        id\n        respondToBotMentions\n      }\n    }\n    error {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1efde2ff8cb6dacba1941833ac6fff93";

export default node;
